import Component from '../core/Component.js'
import Flickity from 'flickity'
import { viewports } from '../core/config'

export const defaults = {
    cellSelector: '[data-ref="GallerySlider:item"]',
    prevNextButtons: false,
    pageDots: false,
    groupCells: true,
    contain: true,
    autoplay: false,
    lazyLoad: 2,
    responzive: true,
    resize: true,
    percentPosition: true
}

export const STATUS = {
    READY: 'is-ready',
    DISABLED: 'is-disabled'
}

export default class GallerySlider extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            slider: null,
            items: [],
            prev: null,
            next: null
        }

        this.options = {
            ...defaults,
        }

        this.flickity = null
        this.index = 0

        this.next = ::this.next
        this.previous = ::this.previous
    }

    prepare() {
        if (this.ref.items.length > 1) {
            this.handleResize()
            window.addEventListener('resize', ::this.handleResize)
        }
    }

    changeSlide(index) {
        if (index == 0) {
            this.ref.prev.classList.add(STATUS.DISABLED)
        } else {
            this.ref.prev.classList.remove(STATUS.DISABLED)
        }

        if (index >= this.flickity.slides.length-1) {
            this.ref.next.classList.add(STATUS.DISABLED)
        } else {
            this.ref.next.classList.remove(STATUS.DISABLED)
        }

        this.index = index
    }

    next(event) {
        event.preventDefault()
        this.flickity.next()
    }

    previous(event) {
        event.preventDefault()
        this.flickity.previous()
    }

    handleResize(event) {
        if (window.innerWidth > viewports.medium[0]) {
            if (this.ref.items.length > 3) {
                this.initSlider()
            } else {
                this.destroySlider()
            }
        } else if (window.innerWidth > viewports.smallWide[0]) {
            if (this.ref.items.length > 2) {
                this.initSlider()
            } else {
                this.destroySlider()
            }
        } else {
            if (this.ref.items.length > 1) {
                this.initSlider()
            } else {
                this.destroySlider()
            }
        }
    }

    initSlider() {
        if (!this.flickity) {
            this.element.classList.add(STATUS.READY)

            this.flickity = new Flickity(this.ref.slider, this.options)

            this.flickity.on('lazyLoad', ( event, cellElement ) => {
                this.flickity.resize()
            });

            window.flickity = this.flickity

            this.ref.prev.addEventListener('click', this.previous)
            this.ref.next.addEventListener('click', this.next)

            this.flickity.on('change', ::this.changeSlide );
        }
    }

    destroySlider() {
        if (this.flickity) {
            this.element.classList.remove(STATUS.READY)

            this.flickity.off('change', ::this.changeSlide );

            this.flickity.destroy()
            this.flickity = null

            this.ref.prev.removeEventListener('click', this.previous)
            this.ref.next.removeEventListener('click', this.next)
        }
    }
}